import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { useState } from "react";
import { MainFaq } from "../../components";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Faq = () => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    // <div>
    <div className="main_loyout">
      <div className="dashboard">
        <h1 className="mn_hdng">Manage Faqs</h1>
      </div>
      <div>
        <Card className="cards">
          <Box className="custom_tabs">
            {/* <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Budget " {...a11yProps(0)} />
                <Tab label="Goals " {...a11yProps(1)} />
                <Tab label="Round Up " {...a11yProps(2)} />
                <Tab label="Savings " {...a11yProps(3)} />
              </Tabs> */}
            <MainFaq />
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default Faq;
